export default __webpack_public_path__ + "static/media/calendar-big-icon.0861c15e.svg";